// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/service/v1/structure_manager.proto (package msh.service.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { AddressFormat } from "../../common/v1/address_pb";
import { WanderingSettings } from "../../resource/v1/wandering_pb";
import { Building, Floor, Room, Structure } from "../../resource/v1/structure_pb";
import { Language } from "../../common/v1/language_pb";
import { IOTCoreCommandStatus, Page, TimeFrame } from "../../common/v1/common_pb";
import { User } from "../../resource/v1/user_pb";
import { Event, EventFilter } from "../../resource/v1/event_pb";
import { Alert, AlertFilter } from "../../resource/v1/alert_pb";

/**
 * @generated from message msh.service.v1.CreateBuildingRequest
 */
export const CreateBuildingRequest = proto3.makeMessageType(
  "msh.service.v1.CreateBuildingRequest",
  () => [
    { no: 1, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "managers", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "users", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "address", kind: "message", T: AddressFormat },
    { no: 6, name: "wandering_settings", kind: "message", T: WanderingSettings },
    { no: 7, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.CreateBuildingResponse
 */
export const CreateBuildingResponse = proto3.makeMessageType(
  "msh.service.v1.CreateBuildingResponse",
  () => [
    { no: 1, name: "building", kind: "message", T: Building },
  ],
);

/**
 * @generated from message msh.service.v1.GetBuildingsRequest
 */
export const GetBuildingsRequest = proto3.makeMessageType(
  "msh.service.v1.GetBuildingsRequest",
  () => [
    { no: 1, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "recursive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message msh.service.v1.GetBuildingsResponse
 */
export const GetBuildingsResponse = proto3.makeMessageType(
  "msh.service.v1.GetBuildingsResponse",
  () => [
    { no: 1, name: "buildings", kind: "message", T: Building, repeated: true },
  ],
);

/**
 * @generated from message msh.service.v1.AddFloorRequest
 */
export const AddFloorRequest = proto3.makeMessageType(
  "msh.service.v1.AddFloorRequest",
  () => [
    { no: 2, name: "building_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.AddFloorResponse
 */
export const AddFloorResponse = proto3.makeMessageType(
  "msh.service.v1.AddFloorResponse",
  () => [
    { no: 1, name: "floor", kind: "message", T: Floor },
  ],
);

/**
 * @generated from message msh.service.v1.GetFloorsRequest
 */
export const GetFloorsRequest = proto3.makeMessageType(
  "msh.service.v1.GetFloorsRequest",
  () => [
    { no: 1, name: "building_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "recursive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message msh.service.v1.GetFloorsResponse
 */
export const GetFloorsResponse = proto3.makeMessageType(
  "msh.service.v1.GetFloorsResponse",
  () => [
    { no: 1, name: "floors", kind: "message", T: Floor, repeated: true },
  ],
);

/**
 * @generated from message msh.service.v1.AddRoomRequest
 */
export const AddRoomRequest = proto3.makeMessageType(
  "msh.service.v1.AddRoomRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.AddRoomResponse
 */
export const AddRoomResponse = proto3.makeMessageType(
  "msh.service.v1.AddRoomResponse",
  () => [
    { no: 1, name: "room", kind: "message", T: Room },
  ],
);

/**
 * @generated from message msh.service.v1.CreateStructureRequest
 */
export const CreateStructureRequest = proto3.makeMessageType(
  "msh.service.v1.CreateStructureRequest",
  () => [
    { no: 1, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lang", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 4, name: "wandering_settings", kind: "message", T: WanderingSettings },
    { no: 5, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.CreateStructureResponse
 */
export const CreateStructureResponse = proto3.makeMessageType(
  "msh.service.v1.CreateStructureResponse",
  () => [
    { no: 1, name: "structure", kind: "message", T: Structure },
  ],
);

/**
 * @generated from message msh.service.v1.GetStructuresRequest
 */
export const GetStructuresRequest = proto3.makeMessageType(
  "msh.service.v1.GetStructuresRequest",
  () => [
    { no: 1, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "recursive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "page", kind: "message", T: Page },
    { no: 4, name: "with_active_alerts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message msh.service.v1.GetStructuresResponse
 */
export const GetStructuresResponse = proto3.makeMessageType(
  "msh.service.v1.GetStructuresResponse",
  () => [
    { no: 1, name: "structures", kind: "message", T: Structure, repeated: true },
    { no: 2, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.UpdateStructureRequest
 */
export const UpdateStructureRequest = proto3.makeMessageType(
  "msh.service.v1.UpdateStructureRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lang", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 4, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.UpdateStructureResponse
 */
export const UpdateStructureResponse = proto3.makeMessageType(
  "msh.service.v1.UpdateStructureResponse",
  () => [
    { no: 1, name: "structure", kind: "message", T: Structure },
  ],
);

/**
 * @generated from message msh.service.v1.AssignResidentRequest
 */
export const AssignResidentRequest = proto3.makeMessageType(
  "msh.service.v1.AssignResidentRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message msh.service.v1.AssignResidentResponse
 */
export const AssignResidentResponse = proto3.makeMessageType(
  "msh.service.v1.AssignResidentResponse",
  () => [
    { no: 1, name: "structure", kind: "message", T: Structure },
  ],
);

/**
 * @generated from message msh.service.v1.GetRoomsRequest
 */
export const GetRoomsRequest = proto3.makeMessageType(
  "msh.service.v1.GetRoomsRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.GetRoomsResponse
 */
export const GetRoomsResponse = proto3.makeMessageType(
  "msh.service.v1.GetRoomsResponse",
  () => [
    { no: 1, name: "rooms", kind: "message", T: Room, repeated: true },
  ],
);

/**
 * The parameters to AddContact
 *
 * @generated from message msh.service.v1.AddContactRequest
 */
export const AddContactRequest = proto3.makeMessageType(
  "msh.service.v1.AddContactRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "building_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "level", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message msh.service.v1.AddContactResponse
 */
export const AddContactResponse = proto3.makeMessageType(
  "msh.service.v1.AddContactResponse",
  [],
);

/**
 * @generated from message msh.service.v1.GetADLStructureEventsRequest
 */
export const GetADLStructureEventsRequest = proto3.makeMessageType(
  "msh.service.v1.GetADLStructureEventsRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "filter", kind: "message", T: EventFilter },
    { no: 3, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetADLStructureEventsResponse
 */
export const GetADLStructureEventsResponse = proto3.makeMessageType(
  "msh.service.v1.GetADLStructureEventsResponse",
  () => [
    { no: 1, name: "events", kind: "message", T: Event, repeated: true },
    { no: 2, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetDeviceOnlineCountRequest
 */
export const GetDeviceOnlineCountRequest = proto3.makeMessageType(
  "msh.service.v1.GetDeviceOnlineCountRequest",
  () => [
    { no: 1, name: "building_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.GetDeviceOnlineCountResponse
 */
export const GetDeviceOnlineCountResponse = proto3.makeMessageType(
  "msh.service.v1.GetDeviceOnlineCountResponse",
  () => [
    { no: 1, name: "total_devices", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "online_devices", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message msh.service.v1.GetBuildingAlertsRequest
 */
export const GetBuildingAlertsRequest = proto3.makeMessageType(
  "msh.service.v1.GetBuildingAlertsRequest",
  () => [
    { no: 1, name: "building_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "filter", kind: "message", T: AlertFilter },
    { no: 3, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetBuildingAlertsResponse
 */
export const GetBuildingAlertsResponse = proto3.makeMessageType(
  "msh.service.v1.GetBuildingAlertsResponse",
  () => [
    { no: 1, name: "alerts", kind: "message", T: Alert, repeated: true },
    { no: 2, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.UpdateBuildingRequest
 */
export const UpdateBuildingRequest = proto3.makeMessageType(
  "msh.service.v1.UpdateBuildingRequest",
  () => [
    { no: 1, name: "building_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.UpdateBuildingResponse
 */
export const UpdateBuildingResponse = proto3.makeMessageType(
  "msh.service.v1.UpdateBuildingResponse",
  () => [
    { no: 1, name: "building", kind: "message", T: Building },
  ],
);

/**
 * @generated from message msh.service.v1.SendStartRecordingStructureCommandRequest
 */
export const SendStartRecordingStructureCommandRequest = proto3.makeMessageType(
  "msh.service.v1.SendStartRecordingStructureCommandRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.SendStartRecordingStructureCommandResponse
 */
export const SendStartRecordingStructureCommandResponse = proto3.makeMessageType(
  "msh.service.v1.SendStartRecordingStructureCommandResponse",
  () => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "message", T: IOTCoreCommandStatus, repeated: true },
  ],
);

/**
 * @generated from message msh.service.v1.SendStopRecordingStructureCommandRequest
 */
export const SendStopRecordingStructureCommandRequest = proto3.makeMessageType(
  "msh.service.v1.SendStopRecordingStructureCommandRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.SendStopRecordingStructureCommandResponse
 */
export const SendStopRecordingStructureCommandResponse = proto3.makeMessageType(
  "msh.service.v1.SendStopRecordingStructureCommandResponse",
  () => [
    { no: 1, name: "status", kind: "message", T: IOTCoreCommandStatus, repeated: true },
  ],
);

/**
 * @generated from message msh.service.v1.SendCancelRecordingStructureCommandRequest
 */
export const SendCancelRecordingStructureCommandRequest = proto3.makeMessageType(
  "msh.service.v1.SendCancelRecordingStructureCommandRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.SendCancelRecordingStructureCommandResponse
 */
export const SendCancelRecordingStructureCommandResponse = proto3.makeMessageType(
  "msh.service.v1.SendCancelRecordingStructureCommandResponse",
  () => [
    { no: 1, name: "status", kind: "message", T: IOTCoreCommandStatus, repeated: true },
  ],
);

/**
 * @generated from message msh.service.v1.GetActivityLevelHistoryRequest
 */
export const GetActivityLevelHistoryRequest = proto3.makeMessageType(
  "msh.service.v1.GetActivityLevelHistoryRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timestamp", kind: "message", T: Timestamp },
    { no: 3, name: "time_frame", kind: "enum", T: proto3.getEnumType(TimeFrame) },
  ],
);

/**
 * @generated from message msh.service.v1.GetActivityLevelHistoryResponse
 */
export const GetActivityLevelHistoryResponse = proto3.makeMessageType(
  "msh.service.v1.GetActivityLevelHistoryResponse",
  () => [
    { no: 1, name: "activities", kind: "message", T: GetActivityLevelHistoryResponse_ActivityHistory, repeated: true },
    { no: 2, name: "histories", kind: "message", T: GetActivityLevelHistoryResponse_ActivityHistory, repeated: true },
  ],
);

/**
 * @generated from message msh.service.v1.GetActivityLevelHistoryResponse.ActivityHistory
 */
export const GetActivityLevelHistoryResponse_ActivityHistory = proto3.makeMessageType(
  "msh.service.v1.GetActivityLevelHistoryResponse.ActivityHistory",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "activity_level", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "GetActivityLevelHistoryResponse_ActivityHistory"},
);

/**
 * @generated from message msh.service.v1.GetADLBuildingEventsRequest
 */
export const GetADLBuildingEventsRequest = proto3.makeMessageType(
  "msh.service.v1.GetADLBuildingEventsRequest",
  () => [
    { no: 1, name: "building_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "filter", kind: "message", T: EventFilter },
    { no: 3, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetADLBuildingEventsResponse
 */
export const GetADLBuildingEventsResponse = proto3.makeMessageType(
  "msh.service.v1.GetADLBuildingEventsResponse",
  () => [
    { no: 1, name: "adl_events", kind: "message", T: GetADLBuildingEventsResponse_ADLEvent, repeated: true },
    { no: 2, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetADLBuildingEventsResponse.ADLEvent
 */
export const GetADLBuildingEventsResponse_ADLEvent = proto3.makeMessageType(
  "msh.service.v1.GetADLBuildingEventsResponse.ADLEvent",
  () => [
    { no: 1, name: "event", kind: "message", T: Event },
    { no: 2, name: "structure", kind: "message", T: Structure },
  ],
  {localName: "GetADLBuildingEventsResponse_ADLEvent"},
);

/**
 * @generated from message msh.service.v1.GetRespirationHistoryRequest
 */
export const GetRespirationHistoryRequest = proto3.makeMessageType(
  "msh.service.v1.GetRespirationHistoryRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timestamp", kind: "message", T: Timestamp },
    { no: 3, name: "time_frame", kind: "enum", T: proto3.getEnumType(TimeFrame) },
  ],
);

/**
 * @generated from message msh.service.v1.GetRespirationHistoryResponse
 */
export const GetRespirationHistoryResponse = proto3.makeMessageType(
  "msh.service.v1.GetRespirationHistoryResponse",
  () => [
    { no: 1, name: "rates", kind: "message", T: GetRespirationHistoryResponse_RespirationHistory, repeated: true },
    { no: 2, name: "histories", kind: "message", T: GetRespirationHistoryResponse_RespirationHistory, repeated: true },
  ],
);

/**
 * @generated from message msh.service.v1.GetRespirationHistoryResponse.RespirationHistory
 */
export const GetRespirationHistoryResponse_RespirationHistory = proto3.makeMessageType(
  "msh.service.v1.GetRespirationHistoryResponse.RespirationHistory",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "GetRespirationHistoryResponse_RespirationHistory"},
);

/**
 * @generated from message msh.service.v1.GetHRHistoryRequest
 */
export const GetHRHistoryRequest = proto3.makeMessageType(
  "msh.service.v1.GetHRHistoryRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timestamp", kind: "message", T: Timestamp },
    { no: 3, name: "time_frame", kind: "enum", T: proto3.getEnumType(TimeFrame) },
  ],
);

/**
 * @generated from message msh.service.v1.GetHRHistoryResponse
 */
export const GetHRHistoryResponse = proto3.makeMessageType(
  "msh.service.v1.GetHRHistoryResponse",
  () => [
    { no: 1, name: "rates", kind: "message", T: GetHRHistoryResponse_HRHistory, repeated: true },
    { no: 2, name: "histories", kind: "message", T: GetHRHistoryResponse_HRHistory, repeated: true },
  ],
);

/**
 * @generated from message msh.service.v1.GetHRHistoryResponse.HRHistory
 */
export const GetHRHistoryResponse_HRHistory = proto3.makeMessageType(
  "msh.service.v1.GetHRHistoryResponse.HRHistory",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "GetHRHistoryResponse_HRHistory"},
);

/**
 * @generated from message msh.service.v1.GetSensorHistoryRequest
 */
export const GetSensorHistoryRequest = proto3.makeMessageType(
  "msh.service.v1.GetSensorHistoryRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timestamp", kind: "message", T: Timestamp },
    { no: 3, name: "time_frame", kind: "enum", T: proto3.getEnumType(TimeFrame) },
    { no: 4, name: "sensor_type", kind: "enum", T: proto3.getEnumType(GetSensorHistoryRequest_SensorType) },
  ],
);

/**
 * @generated from enum msh.service.v1.GetSensorHistoryRequest.SensorType
 */
export const GetSensorHistoryRequest_SensorType = proto3.makeEnum(
  "msh.service.v1.GetSensorHistoryRequest.SensorType",
  [
    {no: 0, name: "SENSOR_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SENSOR_TYPE_TEMPERATURE", localName: "TEMPERATURE"},
    {no: 2, name: "SENSOR_TYPE_PRESSURE", localName: "PRESSURE"},
    {no: 3, name: "SENSOR_TYPE_HUMIDITY", localName: "HUMIDITY"},
    {no: 4, name: "SENSOR_TYPE_AIR_QUALITY", localName: "AIR_QUALITY"},
    {no: 5, name: "SENSOR_TYPE_LIGHT_INTENSITY", localName: "LIGHT_INTENSITY"},
  ],
);

/**
 * @generated from message msh.service.v1.GetSensorHistoryResponse
 */
export const GetSensorHistoryResponse = proto3.makeMessageType(
  "msh.service.v1.GetSensorHistoryResponse",
  () => [
    { no: 1, name: "histories", kind: "message", T: GetSensorHistoryResponse_SensorHistory, repeated: true },
  ],
);

/**
 * @generated from message msh.service.v1.GetSensorHistoryResponse.SensorHistory
 */
export const GetSensorHistoryResponse_SensorHistory = proto3.makeMessageType(
  "msh.service.v1.GetSensorHistoryResponse.SensorHistory",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "mean", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "GetSensorHistoryResponse_SensorHistory"},
);

/**
 * @generated from message msh.service.v1.GetTemperaturesRequest
 */
export const GetTemperaturesRequest = proto3.makeMessageType(
  "msh.service.v1.GetTemperaturesRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "filter", kind: "message", T: EventFilter },
    { no: 3, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetTemperaturesResponse
 */
export const GetTemperaturesResponse = proto3.makeMessageType(
  "msh.service.v1.GetTemperaturesResponse",
  () => [
    { no: 1, name: "events", kind: "message", T: Event, repeated: true },
    { no: 2, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetHumiditiesRequest
 */
export const GetHumiditiesRequest = proto3.makeMessageType(
  "msh.service.v1.GetHumiditiesRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "filter", kind: "message", T: EventFilter },
    { no: 3, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetHumiditiesResponse
 */
export const GetHumiditiesResponse = proto3.makeMessageType(
  "msh.service.v1.GetHumiditiesResponse",
  () => [
    { no: 1, name: "events", kind: "message", T: Event, repeated: true },
    { no: 2, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetPressuresRequest
 */
export const GetPressuresRequest = proto3.makeMessageType(
  "msh.service.v1.GetPressuresRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "filter", kind: "message", T: EventFilter },
    { no: 3, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetPressuresResponse
 */
export const GetPressuresResponse = proto3.makeMessageType(
  "msh.service.v1.GetPressuresResponse",
  () => [
    { no: 1, name: "events", kind: "message", T: Event, repeated: true },
    { no: 2, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetAirQualitiesRequest
 */
export const GetAirQualitiesRequest = proto3.makeMessageType(
  "msh.service.v1.GetAirQualitiesRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "filter", kind: "message", T: EventFilter },
    { no: 3, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetAirQualitiesResponse
 */
export const GetAirQualitiesResponse = proto3.makeMessageType(
  "msh.service.v1.GetAirQualitiesResponse",
  () => [
    { no: 1, name: "events", kind: "message", T: Event, repeated: true },
    { no: 2, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetLightIntensitiesRequest
 */
export const GetLightIntensitiesRequest = proto3.makeMessageType(
  "msh.service.v1.GetLightIntensitiesRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "filter", kind: "message", T: EventFilter },
    { no: 3, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetLightIntensitiesResponse
 */
export const GetLightIntensitiesResponse = proto3.makeMessageType(
  "msh.service.v1.GetLightIntensitiesResponse",
  () => [
    { no: 1, name: "events", kind: "message", T: Event, repeated: true },
    { no: 2, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.SetWanderingSettingsRequest
 */
export const SetWanderingSettingsRequest = proto3.makeMessageType(
  "msh.service.v1.SetWanderingSettingsRequest",
  () => [
    { no: 1, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "wandering_settings", kind: "message", T: WanderingSettings },
  ],
);

/**
 * @generated from message msh.service.v1.SetWanderingSettingsResponse
 */
export const SetWanderingSettingsResponse = proto3.makeMessageType(
  "msh.service.v1.SetWanderingSettingsResponse",
  [],
);

/**
 * @generated from message msh.service.v1.CalculateStatisticsRequest
 */
export const CalculateStatisticsRequest = proto3.makeMessageType(
  "msh.service.v1.CalculateStatisticsRequest",
  () => [
    { no: 1, name: "queue_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "calculation_time", kind: "message", T: Timestamp },
    { no: 3, name: "page", kind: "message", T: Page },
    { no: 4, name: "task_sequence", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message msh.service.v1.CalculateStatisticsResponse
 */
export const CalculateStatisticsResponse = proto3.makeMessageType(
  "msh.service.v1.CalculateStatisticsResponse",
  [],
);

/**
 * @generated from message msh.service.v1.StartTestCoverageRequest
 */
export const StartTestCoverageRequest = proto3.makeMessageType(
  "msh.service.v1.StartTestCoverageRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.StartTestCoverageResponse
 */
export const StartTestCoverageResponse = proto3.makeMessageType(
  "msh.service.v1.StartTestCoverageResponse",
  [],
);

/**
 * @generated from message msh.service.v1.StopTestCoverageRequest
 */
export const StopTestCoverageRequest = proto3.makeMessageType(
  "msh.service.v1.StopTestCoverageRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.StopTestCoverageResponse
 */
export const StopTestCoverageResponse = proto3.makeMessageType(
  "msh.service.v1.StopTestCoverageResponse",
  () => [
    { no: 1, name: "test_result", kind: "message", T: StopTestCoverageResponse_TestCoverageResult, repeated: true },
    { no: 2, name: "test_coverage_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.StopTestCoverageResponse.TestCoverageResult
 */
export const StopTestCoverageResponse_TestCoverageResult = proto3.makeMessageType(
  "msh.service.v1.StopTestCoverageResponse.TestCoverageResult",
  () => [
    { no: 1, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "iot_device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(StopTestCoverageResponse_TestCoverageResult_ResultStatus) },
  ],
  {localName: "StopTestCoverageResponse_TestCoverageResult"},
);

/**
 * @generated from enum msh.service.v1.StopTestCoverageResponse.TestCoverageResult.ResultStatus
 */
export const StopTestCoverageResponse_TestCoverageResult_ResultStatus = proto3.makeEnum(
  "msh.service.v1.StopTestCoverageResponse.TestCoverageResult.ResultStatus",
  [
    {no: 0, name: "RESULT_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "RESULT_STATUS_SUCCEED", localName: "SUCCEED"},
    {no: 2, name: "RESULT_STATUS_FAILED", localName: "FAILED"},
  ],
);

/**
 * @generated from message msh.service.v1.StopTestCoverageTimeoutRequest
 */
export const StopTestCoverageTimeoutRequest = proto3.makeMessageType(
  "msh.service.v1.StopTestCoverageTimeoutRequest",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.StopTestCoverageTimeoutResponse
 */
export const StopTestCoverageTimeoutResponse = proto3.makeMessageType(
  "msh.service.v1.StopTestCoverageTimeoutResponse",
  [],
);

